/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Workingstudent14Inputs */

const en_job_form_enum_workingstudent14 = /** @type {(inputs: Job_Form_Enum_Workingstudent14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working Student`)
};

const de_job_form_enum_workingstudent14 = /** @type {(inputs: Job_Form_Enum_Workingstudent14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werkstudent`)
};

/**
* | output |
* | --- |
* | "Working Student" |
*
* @param {Job_Form_Enum_Workingstudent14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_workingstudent14 = /** @type {((inputs?: Job_Form_Enum_Workingstudent14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Workingstudent14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_workingstudent14(inputs)
	return en_job_form_enum_workingstudent14(inputs)
});
export { job_form_enum_workingstudent14 as "job_form_enum_WORKINGSTUDENT" }